(() => {
  const loader = document.querySelector('[data-dam-wishlist-loader]');
  if (!loader || window.__damWishlistReady) return;
  window.__damWishlistReady = true;
  const labels = loader.dataset;
  const globalNotice = document.querySelector('.dam-wishlist-notice');
  if (globalNotice) document.body.append(globalNotice);
  const storageKey = 'dam:wishlist:v1';
  const limit = 200;
  let opener;
  const message = (key, title = '') => (labels[key] || '').replace('__title__', title);
  const notify = (text) => document.querySelectorAll('[data-dam-wishlist-notice]').forEach((node) => {
    node.textContent = text;
    node.hidden = !text;
  });
  const fail = (key) => { throw new Error(key); };
  const normalize = (item) => {
    if (!item || typeof item.handle !== 'string' || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(item.handle) || /custom|personalized|photo/.test(item.handle)) return fail('invalidProduct');
    if (typeof item.url !== 'string' || typeof item.title !== 'string' || !item.title.trim() || item.title.length > 500 || typeof item.image !== 'string') return fail('invalidProduct');
    const url = new URL(item.url, location.origin);
    if (url.origin !== location.origin || !/^\/(?:en(?:-us)?\/)?products\/[a-z0-9-]+\/?$/.test(url.pathname) || url.pathname.replace(/\/$/, '').split('/').pop() !== item.handle) return fail('invalidProduct');
    const variantId = item.variantId || '';
    if (typeof variantId !== 'string' || (variantId && !/^\d+$/.test(variantId))) return fail('invalidProduct');
    url.search = '';
    url.hash = '';
    if (variantId) url.searchParams.set('variant', variantId);
    let image = '';
    if (item.image) {
      const parsedImage = new URL(item.image, location.origin);
      if (parsedImage.protocol !== 'https:' || ![location.hostname, 'www.diyartmuse.com', 'cdn.shopify.com'].includes(parsedImage.hostname)) return fail('invalidProduct');
      image = parsedImage.href;
    }
    return { handle: item.handle, url: url.pathname + url.search, title: item.title.trim(), image, variantId };
  };
  const read = () => {
    let raw;
    try { raw = localStorage.getItem(storageKey); } catch { return fail('storageBlocked'); }
    if (raw === null) return [];
    try {
      const data = JSON.parse(raw);
      if (data.version !== 1 || !Array.isArray(data.items) || data.items.length > limit) return fail('storageCorrupt');
      const items = data.items.map(normalize);
      if (new Set(items.map((item) => item.handle)).size !== items.length) return fail('storageCorrupt');
      return items;
    } catch { return fail('storageCorrupt'); }
  };
  const write = (items) => {
    const raw = JSON.stringify({ version: 1, items });
    try {
      localStorage.setItem(storageKey, raw);
      if (localStorage.getItem(storageKey) !== raw) return fail('storageBlocked');
    } catch { return fail('storageBlocked'); }
  };
  const metadata = (button) => {
    if (button.dataset.wishlistEligible !== 'ordinary') return fail('invalidProduct');
    if (button.dataset.damWishlistSave === 'cart' && button.closest('[data-key]')?.dataset.key !== button.dataset.wishlistLineKey) return fail('invalidProduct');
    const variantId = button.dataset.damWishlistSave === 'product'
      ? button.closest('[data-pbn-product-experience]')?.querySelector('[data-pbn-main-form] [name="id"]')?.value || button.dataset.wishlistVariant || ''
      : button.dataset.wishlistVariant || '';
    return normalize({ handle: button.dataset.wishlistHandle, title: button.dataset.wishlistTitle, url: button.dataset.wishlistUrl, image: button.dataset.wishlistImage || '', variantId });
  };
  const renderList = (dialog, items) => {
    const list = dialog.querySelector('[data-dam-wishlist-list]');
    const fingerprint = JSON.stringify(items);
    if (list.dataset.fingerprint === fingerprint) return;
    list.dataset.fingerprint = fingerprint;
    const focusHandle = document.activeElement?.dataset.damWishlistRemove;
    const oldIndex = [...list.children].findIndex((row) => row.querySelector('[data-dam-wishlist-remove]')?.dataset.damWishlistRemove === focusHandle);
    const rows = items.map((item) => {
      const row = document.createElement('li');
      const imageLink = document.createElement('a');
      imageLink.href = item.url;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 72;
        image.height = 84;
        imageLink.append(image);
      }
      const copy = document.createElement('div');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.damWishlistRemove = item.handle;
      remove.textContent = labels.remove;
      remove.setAttribute('aria-label', message('removeLabel', item.title));
      copy.append(link, remove);
      row.append(imageLink, copy);
      return row;
    });
    list.replaceChildren(...rows);
    dialog.querySelector('[data-dam-wishlist-empty]').hidden = items.length > 0;
    if (focusHandle) (rows[Math.min(Math.max(oldIndex, 0), rows.length - 1)]?.querySelector('button') || dialog.querySelector('[data-dam-wishlist-close]')).focus();
  };
  const sync = () => {
    let items;
    try { items = read(); } catch (error) {
      document.querySelectorAll('[data-dam-wishlist-count]').forEach((node) => { node.hidden = true; });
      document.querySelectorAll('[data-dam-wishlist-open]').forEach((button) => { button.disabled = false; button.setAttribute('aria-label', labels.open); });
      document.querySelectorAll('[data-dam-wishlist-save]').forEach((button) => {
        button.disabled = false;
        if (button.dataset.damWishlistSave === 'card') button.setAttribute('aria-pressed', 'false');
        const text = button.querySelector('[data-dam-wishlist-save-text]');
        if (text) text.textContent = button.dataset.damWishlistSave === 'cart' ? labels.saveLater : labels.save;
      });
      document.querySelectorAll('[data-dam-wishlist-cart-note], [data-dam-wishlist-cart-remove]').forEach((node) => { node.hidden = true; });
      notify(message(error.message));
      return false;
    }
    document.querySelectorAll('[data-dam-wishlist-open]').forEach((button) => { button.disabled = false; button.setAttribute('aria-label', labels.countLabel.replace('__count__', items.length)); });
    document.querySelectorAll('[data-dam-wishlist-count]').forEach((node) => { node.textContent = items.length; node.hidden = items.length === 0; });
    document.querySelectorAll('[data-dam-wishlist-save]').forEach((button) => {
      let item;
      try { item = metadata(button); } catch { button.disabled = true; return; }
      button.disabled = false;
      const saved = items.find((entry) => entry.handle === item.handle);
      const mode = button.dataset.damWishlistSave;
      if (mode === 'card') {
        button.setAttribute('aria-pressed', String(Boolean(saved)));
        button.setAttribute('aria-label', message(saved ? 'removeLabel' : 'saveLabel', item.title));
      } else {
        const exactSaved = saved?.variantId === item.variantId;
        const text = button.querySelector('[data-dam-wishlist-save-text]');
        if (text) text.textContent = exactSaved ? labels.saved : (mode === 'cart' ? labels.saveLater : labels.save);
        button.setAttribute('aria-label', message('saveLabel', item.title));
        if (mode === 'cart') {
          const row = button.closest('[data-key]');
          const note = row.querySelector('[data-dam-wishlist-cart-note]');
          const removeLabel = row.querySelector('[data-dam-wishlist-cart-remove]');
          if (note) note.hidden = !exactSaved;
          if (removeLabel) removeLabel.hidden = !exactSaved;
        }
      }
    });
    document.querySelectorAll('[data-dam-wishlist-dialog]').forEach((dialog) => renderList(dialog, items));
    return true;
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button || button.disabled) return;
    if (button.matches('[data-dam-wishlist-open]')) {
      sync();
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog?.showModal) { notify(labels.dialogUnavailable); return; }
      opener = button;
      if (!dialog.open) dialog.showModal();
      return;
    }
    if (button.matches('[data-dam-wishlist-close]')) { button.closest('dialog').close(); return; }
    if (!button.matches('[data-dam-wishlist-save], [data-dam-wishlist-remove]')) return;
    event.preventDefault();
    try {
      const items = read();
      const handle = button.dataset.damWishlistRemove;
      let next;
      let removed = Boolean(handle);
      if (handle) next = items.filter((item) => item.handle !== handle);
      else {
        const item = metadata(button);
        const index = items.findIndex((entry) => entry.handle === item.handle);
        removed = button.dataset.damWishlistSave === 'card' && index !== -1;
        if (removed) next = items.filter((entry) => entry.handle !== item.handle);
        else {
          if (index === -1 && items.length >= limit) return fail('limitReached');
          next = [...items];
          if (index === -1) next.push(item);
          else next[index] = item;
        }
      }
      write(next);
      if (sync()) notify(removed ? labels.removed : (button.dataset.damWishlistSave === 'cart' ? labels.cartSaved : labels.saved));
    } catch (error) { notify(message(error.message) || labels.storageBlocked); }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-dam-wishlist-dialog]')) {
      if (opener?.isConnected) opener.focus();
      notify('');
    }
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-pbn-variant], [data-pbn-main-variant]')) queueMicrotask(sync);
  });
  window.addEventListener('storage', (event) => { if (event.key === storageKey || event.key === null) { notify(''); sync(); } });
  const selector = '[data-dam-wishlist-save], [data-dam-wishlist-open], [data-dam-wishlist-dialog]';
  new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) sync();
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
